<div
  class="h-100 d-flex flex-column gap-3"
  [class.p-3]="!isEmbedded"
  [style]="{ 'padding-top': isEmbedded ? '0 !important' : '1rem' }"
>
  @if(showHeader()) {
  <!-- Header image -->
  <!-- <div
  class="header w-100"
  style="height: 200px; overflow: hidden; position: relative"
>
  <img
    [ngSrc]="bannerImageSrc"
    alt="Swiss Jam header image"
    fill
    style="object-fit: cover"
  />
</div> -->

  <!-- Header info -->
  <div class="d-flex flex-row gap-3 w-100 pt-3" [class.p-3]="isEmbedded">
    <div class="flex-grow-1">
      <h2 class="mat-heading-large">{{ name }}</h2>
    </div>
    @if(!isEmbedded) {
    <div class="d-flex flex-row gap-2">
      <a [href]="url" target="_blank" mat-icon-button class="d-flex">
        <mat-icon>launch</mat-icon>
      </a>
      <button mat-icon-button class="d-flex" (click)="shareEvent()">
        <mat-icon>share</mat-icon>
      </button>
      <button mat-icon-button class="d-flex" [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    }
  </div>
  <div [class.p-3]="isEmbedded">
    <p>{{ venueString }}, {{ localityString }}</p>
    <p class="d-flex flex-column">
      <span>
        {{
          readableStartDate !== readableEndDate
            ? readableStartDate + " - " + readableEndDate
            : readableStartDate
        }}
      </span>
      @defer{
      <span>
        <span i18n>Starts in: </span>
        <app-countdown [timestamp]="start"></app-countdown>
      </span>
      }
    </p>
    <p>
      <a [href]="url" target="_blank" mat-stroked-button>
        <mat-icon>launch</mat-icon><span i18n>More Information</span></a
      >
    </p>
  </div>

  <mat-menu #menu="matMenu">
    <button mat-menu-item disabled>
      <mat-icon>report</mat-icon>
      <span i18n>Report</span>
    </button>
    <a
      [routerLink]="['/embed']"
      [queryParams]="{ type: 'event' }"
      class="text-decoration-none"
    >
      <button mat-menu-item>
        <mat-icon>code</mat-icon>
        <span i18n>Embed</span>
      </button>
    </a>
  </mat-menu>
  }

  <!-- <mat-chip-listbox class="py-2">
    <mat-chip-option i18n>Spot Map</mat-chip-option>
    <mat-chip-option i18n disabled>Challenges</mat-chip-option>
  </mat-chip-listbox> -->

  <mat-drawer-container class="flex-grow-1 bg-transparent">
    <mat-drawer
      #drawer
      [opened]="sidenavOpen()"
      class="drawer d-block overflow-x-hidden bg-transparent"
      [class.ps-0]="isEmbedded"
      [class.no-rounding]="isEmbedded"
      mode="side"
      position="end"
    >
      <div
        class="h-100 w-100 drawer-container"
        style="border-radius: 16px"
        [class.no-rounding]="isEmbedded"
      >
        @if(selectedSpot()) {
        <app-spot-details
          @fadeInOut
          [spot]="selectedSpot()"
          [editable]="false"
          [isEditing]="false"
          [dismissable]="true"
          [border]="false"
          (dismiss)="selectedSpot.set(null)"
          [border]="false"
          class="d-block overflow-x-hidden h-100"
        ></app-spot-details>
        } @else {@if(spots() && spots()!.length > 0) {
        <app-spot-list
          @fadeInOut
          class="d-block p-3 h-100 overflow-y-scroll overflow-x-hidden"
          [spots]="spots()"
          [withHrefLink]="false"
          (spotClickIndex)="spotClickedIndex($event)"
          text="Event spots"
          i18n-text
        ></app-spot-list>
        } }
      </div>
    </mat-drawer>

    <!-- Map stuff -->
    <div
      class="h-100 d-flex w-100 overflow-hidden"
      style="border-radius: 16px"
      [class.no-rounding]="isEmbedded"
    >
      @if(swissJamSpotIds.length > 0) { @if(spots() && spots()!.length > 0) {
      <app-map
        @fadeInOut
        #spotMap
        id="spotMap"
        [showGeolocation]="false"
        [boundRestriction]="bounds"
        [polygons]="areaPolygon() ? [areaPolygon()!] : []"
        [minZoom]="16"
        [focusZoom]="focusZoom"
        [mapStyle]="mapStyle"
        [markers]="markers"
        [spots]="spots()"
        [selectedSpot]="selectedSpot()"
        (spotClick)="selectSpot($event)"
        (mapClick)="deselectSpot()"
        [showSpotPreview]="!sidenavOpen()"
        class="w-100 h-100 overflow-hidden d-block"
      ></app-map>
      } }@else { @if(spots() && spots()!.length > 0) {
      <app-spot-map
        @fadeInOut
        #spotMap
        id="spotMap"
        [isClickable]="true"
        [showGeolocation]="false"
        [showSatelliteToggle]="true"
        [boundRestriction]="bounds"
        [polygons]="areaPolygon() ? [areaPolygon()!] : []"
        [minZoom]="16"
        [focusZoom]="focusZoom"
        [centerStart]="markers[markers.length - 1].location"
        [mapStyle]="mapStyle"
        [markers]="markers"
        [spots]="spots()"
        [selectedSpot]="selectedSpot()"
        [showSpotPreview]="!sidenavOpen()"
        (selectedSpotChange)="selectedSpot.set($event)"
        class="w-100 h-100 overflow-hidden d-block"
      ></app-spot-map>
      } }
    </div>

    <div style="top: calc(50% - 36px / 2); right: 5px; position: absolute">
      <button
        mat-icon-button
        (click)="toggleSidenav()"
        class="d-flex border justify-content-center align-items-center p-0"
        style="
          background-color: var(--mat-bottom-sheet-container-background-color);
          border-color: var(
            --mdc-icon-button-icon-color,
            var(--mat-sys-on-surface-variant)
          ) !important;
          border-width: 0.8px !important;
        "
      >
        @if(sidenavOpen()) {
        <mat-icon>chevron_right</mat-icon>
        } @else {
        <mat-icon>chevron_left</mat-icon>}
      </button>
    </div>
  </mat-drawer-container>

  <!-- <div class="d-flex flex-row gap-3">
        @for(marker of markers; track marker) {
        <span
          class="d-flex flex-row gap-1 mat-title-small justify-content-center align-items-center"
          ><app-marker
            [icon]="marker.icon"
            [color]="marker.color"
            [size]="0.8"
          ></app-marker>
          {{ marker.name }}</span
        >
        }
      </div> -->
  <!-- <div class="col-md-6 col-lg-4 pb-5">
      @if(selectedSpot()) {
      <app-spot-details
        @fadeInOut
        [spot]="selectedSpot()"
        [editable]="false"
        [isEditing]="false"
        [dismissable]="true"
        [border]="true"
        (dismiss)="selectedSpot.set(null)"
      ></app-spot-details>
      } @else {@if(spots?.length > 0) {
      <app-spot-list
        @fadeInOut
        [spots]="spots"
        [withHrefLink]="false"
        (spotClickIndex)="spotClickedIndex($event)"
        text="Event spots"
        i18n-text
      ></app-spot-list>
      } }
    </div> -->
</div>
